import React from "react";
import { Wrench, Cpu, Cog, FlaskConical } from "lucide-react";
import { skillGroups } from "../data/mock";

const groupIcon = {
  "CAD & Design": Cog,
  "Simulation & Analysis": FlaskConical,
  "Manufacturing": Wrench,
  "Programming & Tools": Cpu,
};

const Skills = () => {
  return (
    <section id="skills" className="relative py-24 lg:py-32 border-t border-teal-500/10">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-teal-500/40 to-transparent" />
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-14">
          <div className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-[0.2em] text-teal-400 mb-4">
            <span className="w-8 h-px bg-teal-400" /> 06 — Skills
          </div>
          <h2 className="font-display text-4xl lg:text-5xl font-bold leading-tight">
            The tools in my <span className="text-teal-300">workshop</span>.
          </h2>
          <p className="mt-4 text-slate-400">
            A blend of CAD, simulation, hands-on manufacturing, and code — because real engineers ship across the stack.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-5">
          {skillGroups.map((g) => {
            const Icon = groupIcon[g.title] || Cog;
            return (
              <div
                key={g.title}
                className="rounded-2xl border border-teal-500/15 bg-[#08201d]/60 p-7 hover:border-teal-400/40 transition-colors"
              >
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-11 h-11 rounded-lg bg-teal-500/15 text-teal-300 flex items-center justify-center">
                    <Icon className="w-5 h-5" />
                  </div>
                  <h3 className="font-display text-xl font-semibold text-slate-100">
                    {g.title}
                  </h3>
                </div>
                <div className="space-y-4">
                  {g.items.map((s) => (
                    <div key={s.name}>
                      <div className="flex items-center justify-between mb-1.5">
                        <span className="text-sm text-slate-200">{s.name}</span>
                        <span className="text-xs font-mono text-teal-300">
                          {s.level}%
                        </span>
                      </div>
                      <div className="h-1.5 rounded-full bg-teal-500/10 overflow-hidden">
                        <div
                          className="h-full rounded-full bg-gradient-to-r from-teal-500 to-teal-300"
                          style={{ width: `${s.level}%` }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Skills;
